<template>
  <ReactPage>
    <special-prize-condition-config-page></special-prize-condition-config-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "SpecialPrizeConditionReactConfig",
  components: {
    ReactPage
  }
}
</script>